var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.985,
    height: 21.695,
    viewBox: "0 0 30.985 21.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M30.347-2.687a3.882,3.882,0,0,0-2.731-2.731c-2.425-.663-12.124-.663-12.124-.663s-9.7,0-12.123.638A3.961,3.961,0,0,0,.639-2.687,40.9,40.9,0,0,0,0,4.765a40.752,40.752,0,0,0,.638,7.453A3.882,3.882,0,0,0,3.37,14.949c2.45.664,12.123.664,12.123.664s9.7,0,12.123-.638a3.882,3.882,0,0,0,2.731-2.731,40.916,40.916,0,0,0,.638-7.453,38.827,38.827,0,0,0-.638-7.478ZM12.4,9.41V.12L20.47,4.765Zm0,0",
    transform: "translate(-0.001 6.082)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0d751b1b6467762f9931434f051e2993.svg";
export { ForwardRef as ReactComponent };